module.exports = __webpack_public_path__ + "img/Retail26.435bb660.png";